import * as React from 'react';
import PropTypes from 'prop-types';
import { Provider, connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

// import ReactGA from 'react-ga';
import Routes from './routes';
import { outdated } from './detectBrowser';

class Main extends React.PureComponent {
  componentWillMount() {
    this.browser();
    // ReactGA.initialize('UA-105661825-5');
  }

  browser() {
    const { history } = this.props;
    if (outdated) {
      history.push('unsupported');
      history.block();
    }
  }

  render() {
    this.browser();
    const { store, history } = this.props;

    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Routes />
        </ConnectedRouter>
      </Provider>
    );
  }
}

Main.propTypes = {
  store: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired
};

export default connect()(Main);



// WEBPACK FOOTER //
// ./src/main.jsx